import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withModifiers as _withModifiers, withCtx as _withCtx, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  id: "badges-container",
  "class": "tw-absolute tw-top-10px tw-left-10px tw-z-10 tw-flex tw-gap-10px tw-items-center"
};
var _hoisted_2 = {
  key: 0,
  "class": "tw-shadow-sm"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = ["src", "srcset"];
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  "class": "tw-text-20 tw-font-semibold tw-mb-10px"
};
var _hoisted_7 = {
  key: 0
};
var _hoisted_8 = {
  key: 1
};
var _hoisted_9 = {
  key: 0,
  "class": "tw-text-18 tw-font-regular tw-mt-0 tw-mb-15px"
};
var _hoisted_10 = {
  key: 1,
  "class": "tw-flex tw-gap-x-15px tw-items-center property-details tw-flex-wrap sm:tw-flex-nowrap tw-bg-w-cultured tw-py-5px tw-rounded-[10px] tw-w-full"
};
var _hoisted_11 = {
  key: 0,
  "class": "tw-inline-flex tw-items-center tw-justify-center tw-flex-[1_0_auto]"
};
var _hoisted_12 = {
  "class": "tw-flex tw-items-center tw-justify-center tw-p-5px tw-mr-5px"
};
var _hoisted_13 = ["src"];
var _hoisted_14 = {
  "class": "tw-font-semibold tw-text-12"
};
var _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  "class": "tw-text-12"
}, [/*#__PURE__*/_createTextVNode("m"), /*#__PURE__*/_createElementVNode("sup", null, "2")], -1 /* HOISTED */);
var _hoisted_16 = {
  key: 1,
  "class": "tw-block tw-border-l tw-border-w-secondary tw-border-solid tw-h-1/2"
};
var _hoisted_17 = {
  key: 2,
  "class": "tw-inline-flex tw-items-center tw-justify-center tw-flex-[1_0_auto]"
};
var _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  "class": "tw-block tw-border-l tw-border-w-secondary tw-border-solid tw-h-1/2"
}, null, -1 /* HOISTED */);
var _hoisted_19 = {
  "class": "tw-flex tw-items-center tw-justify-center tw-p-5px tw-mr-5px"
};
var _hoisted_20 = ["src"];
var _hoisted_21 = {
  key: 0,
  "class": "tw-font-semibold tw-text-12"
};
var _hoisted_22 = {
  key: 1
};
var _hoisted_23 = {
  "class": "tw-hidden sm:tw-block"
};
var _hoisted_24 = {
  key: 3,
  "class": "tw-block tw-border-l tw-border-w-secondary tw-border-solid tw-h-1/2"
};
var _hoisted_25 = {
  key: 4,
  "class": "tw-inline-flex tw-items-center tw-justify-center tw-flex-[1_0_auto]"
};
var _hoisted_26 = /*#__PURE__*/_createElementVNode("div", {
  "class": "tw-block tw-border-l tw-border-w-secondary tw-border-solid tw-h-1/2"
}, null, -1 /* HOISTED */);
var _hoisted_27 = {
  "class": "tw-flex tw-items-center tw-justify-center tw-p-5px tw-mr-5px"
};
var _hoisted_28 = ["src"];
var _hoisted_29 = {
  key: 0,
  "class": "tw-font-semibold tw-text-12"
};
var _hoisted_30 = {
  key: 1
};
var _hoisted_31 = {
  "class": "tw-hidden sm:tw-block"
};
var _hoisted_32 = {
  key: 5,
  "class": "tw-block tw-border-l tw-border-w-secondary tw-border-solid tw-h-1/2"
};
var _hoisted_33 = {
  key: 6,
  "class": "tw-inline-flex tw-items-center tw-justify-center tw-flex-[1_0_auto]"
};
var _hoisted_34 = {
  "class": "tw-flex tw-items-center tw-justify-center tw-p-5px tw-mr-5px"
};
var _hoisted_35 = ["src"];
var _hoisted_36 = {
  "class": "tw-font-semibold tw-text-12"
};
import BaseCard from "@vueEntry/UIKitComponents/BaseCard.vue";
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import { formatInteger } from "@utils/NumberUtils";
import { redirect } from "@utils/RedirectUtils";
import { useCommonVars } from "@wkComposables/useCommonVars";
import { computed, defineAsyncComponent } from "vue";
import { useFavourite } from "@wkComposables/useFavourite";
import { HeartIcon } from "@vueEntry/SvgIcons/HeartIcon";
import { usePublicUserMenuStore } from "@wkWebSrc/js/store";
import { useBreakpoints } from "@wkComposables/useBreakpoints";
export default /*#__PURE__*/_defineComponent(Object.assign({
  inheritAttrs: false
}, {
  __name: 'InsertionCard',
  props: {
    realEstate: {},
    vertical: {
      type: Boolean,
      "default": false
    },
    showAddressInfo: {
      type: Boolean,
      "default": true
    },
    cardImageClasses: {
      "default": ""
    },
    cardDescriptionClasses: {
      "default": ""
    },
    enableCarousel: {
      type: Boolean,
      "default": false
    }
  },
  emits: ["open-url"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var SwiperCarousel = defineAsyncComponent(function () {
      return import("@vueEntry/SwiperCarousel.vue");
    });
    var _useCommonVars = useCommonVars(),
      cdn = _useCommonVars.cdn,
      wkLabels = _useCommonVars.wkLabels;
    var _useFavourite = useFavourite(),
      handleAddFavorite = _useFavourite.handleAddFavorite,
      handleRemoveFavorite = _useFavourite.handleRemoveFavorite;
    var _useBreakpoints = useBreakpoints(),
      isDesktopMode = _useBreakpoints.isDesktopMode;
    var publicMenuUserStore = usePublicUserMenuStore();
    //@ts-ignore
    var typology = computed(function () {
      return window["_typologyLabel"];
    });
    //@ts-ignore
    var rooms = computed(function () {
      return props.realEstate.rooms > 1 ? window["_roomsLabel"] : window["_roomLabel"];
    });
    //@ts-ignore
    var bathrooms = computed(function () {
      return props.realEstate.bathrooms > 1 ? window["_bathroomsLabel"] : window["_bathroomLabel"];
    });
    //@ts-ignore
    var sqM = computed(function () {
      return formatInteger(props.realEstate.sqM || props.realEstate.sqm);
    });
    // eslint-disable-next-line max-len
    var price = computed(function () {
      return formatInteger(props.realEstate.sale ? props.realEstate.priceSale : props.realEstate.auction ? props.realEstate.auctionMinimumOffer : props.realEstate.priceRent);
    });
    // eslint-disable-next-line max-len
    var isCharacteristicAvailable = computed(function () {
      return (props.realEstate.sqM || props.realEstate.sqm) && (props.realEstate.sqM > 0 || props.realEstate.sqm > 0) || props.realEstate.rooms && props.realEstate.rooms > 0 || !props.realEstate.auction && props.realEstate.bathrooms && props.realEstate.bathrooms > 0 || !props.realEstate.auction && props.realEstate.energyClass;
    });
    var imageUrl = computed(function () {
      var _a;
      return "".concat(window["_baseURLIt"], "/rest/realEstate/").concat(props.realEstate.realEstateID, "/images/").concat((_a = props.realEstate.description) === null || _a === void 0 ? void 0 : _a.toLowerCase().replace(" ", "-"), "_foto-1_small.jpg");
    });
    var isREInFavorites = computed(function () {
      var _a;
      return publicMenuUserStore.getFavoriteById((_a = props.realEstate.id) !== null && _a !== void 0 ? _a : props.realEstate.realEstateID) >= 0;
    });
    var openURL = function openURL() {
      redirect({
        url: props.realEstate.id ? "".concat(window["_baseURL"], "/").concat(props.realEstate.id) : "".concat(window["_baseURL"]).concat(props.realEstate.url),
        blankPage: {
          lg: true
        }
      });
      emits("open-url");
    };
    /*
    const setFavoritesIcon = (hover = false) : {"fill-color": string, "stroke-color": string} | {"stroke-color": string} =>{
        const white = "#fff"
        const red ="#FA4F64"
    
        if(hover)
            return isREInFavorites.value ? {"stroke-color": white} : {"fill-color": red, "stroke-color": red}
        else
            return isREInFavorites.value ? {"fill-color": red, "stroke-color": red} : {"stroke-color": white}
    }
    */
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(BaseCard, {
        "class": _normalizeClass(["tw-border-w-secondary md:tw-cursor-pointer tw-bg-white", _ctx.$attrs['class']]),
        "data-cy": _ctx.$attrs['data-cy'],
        type: _ctx.vertical && 'vertical',
        "card-img-classes": "tw-shrink-0 tw-border-0 tw-relative tw-bg-w-lavender sm:max-md:!tw-w-[250px] ".concat(_ctx.cardImageClasses),
        "card-body-classes": "!tw-p-15px sm:!tw-p-20px tw-flex tw-flex-col tw-justify-between !tw-h-full ".concat(_ctx.cardDescriptionClasses),
        onClick: openURL
      }, {
        "card-image": _withCtx(function () {
          var _a, _b, _c;
          return [_createElementVNode("div", _hoisted_1, [((_a = _ctx.realEstate) === null || _a === void 0 ? void 0 : _a.auction) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("img", {
            height: "32",
            width: "32",
            "class": "tw-h-auto",
            src: "".concat(_unref(cdn), "/_ui/img/Ico/auction-hammer.svg"),
            alt: "Icona aste"
          }, null, 8 /* PROPS */, _hoisted_3)])) : _createCommentVNode("v-if", true)]), _ctx.enableCarousel ? (_openBlock(), _createBlock(_unref(SwiperCarousel), {
            key: 0,
            id: "insertion-carousel-".concat(_ctx.realEstate.id || _ctx.realEstate.realEstateID),
            "root-classes": "tw-h-full",
            "swiper-classes": "tw-h-full",
            "slide-img-classes": "!tw-object-cover tw-w-full tw-h-full",
            "shift-first-image": true,
            "swiper-options": {
              pagination: {
                dynamicBullets: true
              },
              navigation: {
                enabled: false
              },
              breakpoints: {
                576: {
                  navigation: {
                    enabled: true
                  }
                }
              }
            },
            images: (_b = _ctx.realEstate) === null || _b === void 0 ? void 0 : _b.reImages
          }, null, 8 /* PROPS */, ["id", "images"])) : ((_c = _ctx.realEstate) === null || _c === void 0 ? void 0 : _c.reImages) && _ctx.realEstate.reImages[0] ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            "class": "tw-object-cover tw-h-full tw-w-full",
            src: "".concat(_ctx.realEstate.reImages[0].images[2].storagePath),
            srcset: "".concat(_ctx.realEstate.reImages[0].images[1].storagePath, " 320w, ").concat(_ctx.realEstate.reImages[0].images[2].storagePath, " 640w, ").concat(_ctx.realEstate.reImages[0].images[2].storagePath, " 1280w"),
            sizes: "(max-width: 575px) 100vw, (min-width: 576px) and (max-width: 767px) 640px, 480px",
            alt: "real estate image"
          }, null, 8 /* PROPS */, _hoisted_4)) : (_openBlock(), _createElementBlock("img", {
            key: 2,
            "class": "tw-object-cover tw-h-full tw-w-full",
            src: imageUrl.value,
            alt: "real estate image"
          }, null, 8 /* PROPS */, _hoisted_5)), _withDirectives(_createVNode(BaseButton, {
            "class": "!tw-p-0 tw-min-w-20px tw-h-20px tw-absolute tw-top-[15px] tw-right-[15px] tw-z-10",
            "btn-class": "tw-btn-transparent tw-btn-sm",
            "data-cy": "favorite-btn",
            onClick: _cache[0] || (_cache[0] = _withModifiers(function ($event) {
              var _a, _b, _c;
              return _unref(handleAddFavorite)((_b = (_a = _ctx.realEstate) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : (_c = _ctx.realEstate) === null || _c === void 0 ? void 0 : _c.realEstateID);
            }, ["stop", "prevent"]))
          }, {
            "default": _withCtx(function () {
              return [_createVNode(_unref(HeartIcon), {
                width: 20,
                height: 20,
                "class": "tw-inline-block",
                "stroke-color": "#FFF"
              })];
            }),
            _: 1 /* STABLE */
          }, 512 /* NEED_PATCH */), [[_vShow, !isREInFavorites.value]]), _withDirectives(_createVNode(BaseButton, {
            "class": "!tw-p-0 tw-min-w-20px tw-h-20px tw-absolute tw-top-[15px] tw-right-[15px] tw-z-10",
            "btn-class": "tw-btn-transparent tw-btn-sm",
            "data-cy": "favorite-btn",
            onClick: _cache[1] || (_cache[1] = _withModifiers(function ($event) {
              var _a, _b, _c;
              return _unref(handleRemoveFavorite)((_b = (_a = _ctx.realEstate) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : (_c = _ctx.realEstate) === null || _c === void 0 ? void 0 : _c.realEstateID);
            }, ["stop", "prevent"]))
          }, {
            "default": _withCtx(function () {
              return [_createVNode(_unref(HeartIcon), {
                width: 20,
                height: 20,
                "fill-color": "#FA4F64",
                "stroke-color": "#FA4F64",
                "class": "tw-inline-block"
              })];
            }),
            _: 1 /* STABLE */
          }, 512 /* NEED_PATCH */), [[_vShow, isREInFavorites.value]])];
        }),
        "card-description": _withCtx(function () {
          var _a, _b;
          return [_createElementVNode("p", _hoisted_6, [_ctx.realEstate.reservedPrice ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(wkLabels).reservedPrice), 1 /* TEXT */)) : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(((_a = _ctx.realEstate) === null || _a === void 0 ? void 0 : _a.auction) ? _unref(wkLabels).from : '') + " € " + _toDisplayString(price.value || new Intl.NumberFormat('it-IT').format((_b = _ctx.realEstate) === null || _b === void 0 ? void 0 : _b.price)), 1 /* TEXT */))]), _ctx.showAddressInfo ? (_openBlock(), _createElementBlock("h4", _hoisted_9, [_createElementVNode("span", null, _toDisplayString(_ctx.realEstate.title), 1 /* TEXT */)])) : _createCommentVNode("v-if", true), isCharacteristicAvailable.value ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [(props.realEstate.sqM || props.realEstate.sqm) && (props.realEstate.sqM > 0 || props.realEstate.sqm > 0) ? (_openBlock(), _createElementBlock("li", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("img", {
            src: "".concat(_unref(cdn), "/_ui/img/Ico/square-meter.svg"),
            height: "16",
            width: "16",
            alt: "icona metri quadrati"
          }, null, 8 /* PROPS */, _hoisted_13)]), _createElementVNode("span", _hoisted_14, _toDisplayString(sqM.value), 1 /* TEXT */), _createTextVNode("  "), _hoisted_15])) : _createCommentVNode("v-if", true), _ctx.realEstate.rooms ? (_openBlock(), _createElementBlock("li", _hoisted_16)) : _createCommentVNode("v-if", true), _ctx.realEstate.rooms ? (_openBlock(), _createElementBlock("li", _hoisted_17, [_hoisted_18, _createElementVNode("div", _hoisted_19, [_createElementVNode("img", {
            src: "".concat(_unref(cdn), "/_ui/img/Ico/rooms.svg"),
            height: "16",
            width: "16",
            alt: "icona stanze"
          }, null, 8 /* PROPS */, _hoisted_20)]), _ctx.realEstate.rooms < 11 ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.realEstate.rooms), 1 /* TEXT */)) : (_openBlock(), _createElementBlock("span", _hoisted_22, "10+")), _createTextVNode("  "), _createElementVNode("span", _hoisted_23, _toDisplayString(rooms.value), 1 /* TEXT */)])) : _createCommentVNode("v-if", true), !_ctx.realEstate.auction && _ctx.realEstate.bathrooms ? (_openBlock(), _createElementBlock("li", _hoisted_24)) : _createCommentVNode("v-if", true), !_ctx.realEstate.auction && _ctx.realEstate.bathrooms ? (_openBlock(), _createElementBlock("li", _hoisted_25, [_hoisted_26, _createElementVNode("div", _hoisted_27, [_createElementVNode("img", {
            src: "".concat(_unref(cdn), "/_ui/img/Ico/bath.svg"),
            height: "16",
            width: "16",
            alt: "icona bagno"
          }, null, 8 /* PROPS */, _hoisted_28)]), _ctx.realEstate.bathrooms < 6 ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.realEstate.bathrooms), 1 /* TEXT */)) : (_openBlock(), _createElementBlock("span", _hoisted_30, "5+")), _createTextVNode("  "), _createElementVNode("span", _hoisted_31, _toDisplayString(bathrooms.value), 1 /* TEXT */), _createTextVNode("  ")])) : _createCommentVNode("v-if", true), !_ctx.realEstate.auction && _ctx.realEstate.energyClass ? (_openBlock(), _createElementBlock("li", _hoisted_32)) : _createCommentVNode("v-if", true), !_ctx.realEstate.auction && _ctx.realEstate.energyClass ? (_openBlock(), _createElementBlock("li", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("img", {
            src: "".concat(_unref(cdn), "/_ui/img/Ico/energy-class.svg"),
            height: "16",
            width: "16",
            alt: "energy class icon"
          }, null, 8 /* PROPS */, _hoisted_35)]), _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.realEstate.energyClass), 1 /* TEXT */)])) : _createCommentVNode("v-if", true)])) : _createCommentVNode("v-if", true)];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["class", "data-cy", "type", "card-img-classes", "card-body-classes"]);
    };
  }
}));